import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/AdvertisementManagement';
import { waitAuthorizedCheck } from './Auth';

function* getAds(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: `/api/v1/event/${action.payload.event_name}/ads/`,
                body: {
                    ...(action.payload.page && { page: action.payload.page }),
                    ...(action.payload.page_size && { page_size: action.payload.page_size }),
                    ...(action.payload.company_id && { company_id: action.payload.company_id }),
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.GetAdvertisementReceived(response));
    } catch (error) {
        yield put(Actions.GetAdvertisementReceiveFailure(yield error));
    }
}

function* createAds(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.postWithFile,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/ads/`,
                body: {
                    ...(action.payload.image && { image: action.payload.image }),
                    ...(action.payload.description && { description: action.payload.description }),
                    ...(action.payload.description_en && { description_en: action.payload.description_en }),
                    ...(action.payload.url && { url: action.payload.url }),
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.CreateAdvertisementReceived(response));
    } catch (error) {
        yield put(Actions.CreateAdvertisementReceiveFailure(yield error));
    }
}

function* updateAds(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.putWithFile,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/ads/${action.payload.ads_id}/`,
                body: {
                    ...(action.payload.image && { image: action.payload.image }),
                    ...(action.payload.description && { description: action.payload.description }),
                    ...(action.payload.description_en && { description_en: action.payload.description_en }),
                    ...(action.payload.url && { url: action.payload.url }),
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.UpdateAdvertisementReceived(response));
    } catch (error) {
        yield put(Actions.UpdateAdvertisementReceiveFailure(yield error));
    }
}

function* deleteAds(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.delete,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/ads/${action.payload.ads_id}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.DeleteAdvertisementReceived(response));
    } catch (error) {
        yield put(Actions.DeleteAdvertisementReceiveFailure(yield error));
    }
}

export default function* SurveyManagement() {
    yield all([
        takeLatest('GET_ADVERTISEMENT_REQUESTED', getAds),
        takeLatest('CREATE_ADVERTISEMENT_REQUESTED', createAds),
        takeLatest('UPDATE_ADVERTISEMENT_REQUESTED', updateAds),
        takeLatest('DELETE_ADVERTISEMENT_REQUESTED', deleteAds),
    ]);
}
